import { useConfidenceCoreContext } from '@spotify/confidence-core-react';

import { WorkflowExtensionOptions } from '../../extensions';

export const useWorkflowExtensions = () => {
  const { config } = useConfidenceCoreContext();
  return (config.workflowExtensions ?? []) as WorkflowExtensionOptions[];
};
